// import { Link } from "react-router-dom";

import ImageGrid from "./ImageGrid";
import { admindata } from "../../sample-data/admindata";
import { useSelector, useDispatch } from 'react-redux';
import { logout } from '../../redux/action';
import Layout from "../../component/Header/Layout";
import { hasPermission } from "../../Utills/permission";
import { roleMap, packageMap } from "../../Utills/enums";

function AdminHome(params) {

    // const dispatch = useDispatch();
    // const handleLogout = (e) => {
    //     try {
    //         dispatch(logout());
    //         console.log("Logout:"); // token or restros

    //     } catch (error) {
    //         console.error("Logot failed:", error.message);
    //     }
    // }

    // 1. Storage se authenticated info fetch karein
    const userTokenInfo = JSON.parse(localStorage.getItem("admin_token_info")) || {};
    
    // 2. Maps ko use karke clear Role aur Plan identify karein
    const role = roleMap[userTokenInfo?.roleId];
    const plan = packageMap[userTokenInfo?.packageId];

    // 3. Admin Data Array ko unhi features par filter karein jinki permission true hai
    const filteredGridData = admindata.filter(item => {
        // Agar permission true hai toh card dikhega, warna list se filter out ho jayega
        return hasPermission(role, plan, item.feature);
    });

    return (<>
        <ImageGrid imageData={filteredGridData} />
        {/* <ImageGrid imageData={admindata} /> */}
    </>);
}

export default AdminHome;